import { useEffect, useState } from 'react';

/** Incremental rendering for APIs which currently return complete lists.
 * This limits DOM work, not network transfer; use cursor APIs for larger datasets.
 */
export function useIncrementalItems<T>(items: readonly T[], pageSize: number, resetKey: string) {
  const [state, setState] = useState({ key: resetKey, count: pageSize });
  // Always reset the batch when the scope or search changes, including if the
  // user later returns to a previously expanded filter.
  useEffect(() => {
    setState({ key: resetKey, count: pageSize });
  }, [resetKey, pageSize]);
  const count = state.key === resetKey ? state.count : pageSize;
  const visible = items.slice(0, count);
  return {
    visible,
    loaded: visible.length,
    total: items.length,
    hasMore: count < items.length,
    loadMore: () => setState({ key: resetKey, count: count + pageSize }),
  };
}
